// extracted by css-extract-rspack-plugin
export default {"appIcon":"kNBJl_ST6bYyWnRV"};